import { Component, OnDestroy, OnInit } from '@angular/core';
import { processorNamesConstant } from '../../../core/routing/constants/processor-names.constant';
import { osNameConstant } from '../../../core/routing/constants/os-names.constant';
import { graphicsModelsConstant } from '../../../core/routing/constants/graphics-models.constant';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { LANGUAGE_MAPPINGS } from '../../../common/constants/language-mappings.const';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { User } from '../../account/login/_models/user.model';
import { AppGlobal } from '../../../../../src/app/core/state/app-global';
import { HeroTile, Sku } from '../../create-profile/interface/profile.i';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { PromoContent } from '../../asset-library/promo-content/interfaces/promo-content.i';
import { Segment } from '../../asset-library/segments/interfaces/segments.i';
import { SkuIdInfoService } from '../../../core/routing/services/sku-ids/sku-id-info.service';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';

@Component({
  selector: 'iposcen-upload-sku-csv',
  templateUrl: './upload-sku-csv.component.html',
  styleUrls: ['./upload-sku-csv.component.scss']
})
export class UploadSkuCsvComponent implements OnInit, OnDestroy {
  uploadCSVNote = GlobalConstants.UPLOAD_CSV_NOTE;
  dasDecimalPointValidationMsg = GlobalConstants.DAS_DECIMALPOINT_VALIDATION_DESC;
  uploadedCSVError = GlobalConstants.WRONG_TEMPLATE_ERROR;
  isRepairabilityIndexEnabled: boolean;
  isCustomTileEnabled = false;
  isPriceSupress: boolean;
  userRole: string;
  retailerConfig: any;
  repairabilityPositive: boolean;
  isRepairabilitySizeError: boolean;
  isRepairabilityDecimal: boolean;
  riPositiveValueChecker: number;
  sku: Sku[];
  fileName: string;
  riRangeErrorChecker: number;
  dasTeteDecimalPointChecker: number;
  dasTroncDecimalPointChecker: number;
  dasMembreDecimalPointChecker: number;
  file: any = {};
  skuValidationError = false;
  showcsvError = false;
  csvTemplateError: boolean;
  isSkuCodeAvailable: boolean;
  isSkuCodeDuplicate: boolean;
  isBatteryPositive: boolean;
  isDeviceNameExists = true;
  isPrimaryPriceExists = true;
  isSkuCodeAvailableError: boolean;
  isProcessorExists = true;
  isSkuCodeDuplicateError: boolean;
  isBatteryLifeError: boolean;
  settings: any;
  unMatchedProcessorList = [];
  emptyProcessorsList = [];
  incorrectProcessorExists: boolean;
  incorrectOSExists: boolean;
  incorrectGraphicsCardExists: boolean;
  skuFileName: string;
  allHeroTile: HeroTile[];
  isExpanded = false;
  locationListObj = [];
  emptyDeviceSkuList = [];
  emptyPrimaryPriceList = [];
  successPopUp = false;
  columnOneProcessorList = [];
  processorListColumnOne = [];
  processorListColumnTwo = [];
  osListColumn = [];
  graphicsListColumn = [];
  isProcessorListExpanded: boolean;
  isOSListExpanded: boolean;
  isGraphicsListExpanded: boolean;
  selectedLang: string;
  isPromoExists: boolean;
  isCustomTileexists: boolean;
  isSegmentExists: boolean;
  allPromoContentGroups: PromoContent[];
  segmentsGroups: Segment[];
  downloadFile = new Date().toLocaleDateString() + '_' + GlobalConstants.SKU_CSV_FILENAME + '.csv';
  inEnglishText = GlobalConstants.INENGLISH;
  langName: string;
  userId: string = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerId: string = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private appGlobal: AppGlobal,
    private createProfileService: CreateProfileService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private skuService: SkuIdInfoService) { }

  ngOnInit(): void {
    this.selectedLang = localStorage.getItem(GlobalConstants.PREFERRED_LANGUAGE);
    this.langName = LANGUAGE_MAPPINGS.find(ele => ele.langCode === this.selectedLang).langInEng;
    this.isProcessorListExpanded = false;
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.getRetailerConfig();
          this.isRepairabilityIndexEnabled = this.retailerConfig.isRepairabilityIndexEnabled ? this.retailerConfig.isRepairabilityIndexEnabled : false;
          this.isCustomTileEnabled = this.retailerConfig?.customSrtEnabled ? this.retailerConfig?.customSrtEnabled : false;
          this.isPriceSupress = this.retailerConfig?.isPriceSupress ? this.retailerConfig?.isPriceSupress : false;
        }
      });
    this.getAllProcessorNames();
    this.getAllOSNames();
    this.getAllGraphicsModelNames();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getRetailerConfig() {
    return new Promise((resolve) => {
      this.createProfileService.getUserRoleData(this.userId, this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          const config = JSON.parse(data?.retailer?.configurations);
          resolve(config);
        })
    })
  }

  getAllOSNames() {
    let osListArray = [];
    osNameConstant.forEach(ele => {
      osListArray.push({
        name: ele.name
      });
      this.osListColumn = osListArray;
      this.osListColumn.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getAllGraphicsModelNames() {
    let graphicsListArray = [];
    graphicsModelsConstant.forEach(ele => {
      graphicsListArray.push({
        name: ele.name
      });
      this.graphicsListColumn = graphicsListArray;
      this.graphicsListColumn.sort((a, b) => b.name - a.name);
    });
  }

  getAllProcessorNames() {
    processorNamesConstant.forEach(item => {
      this.columnOneProcessorList.push({
        name: item.name,
        nameInEng: item.nameInEng,
        order: item.group
      });
      const group1 = this.setProcessorListGrouping(this.columnOneProcessorList, GlobalConstants.TRANSLATED);
      this.processorListColumnOne = Object.keys(group1).map(function (key) {
        return { order: key, name: group1[key] };
      });
      this.processorListColumnOne.sort((a, b) => b.order - a.order);
      const group2 = this.setProcessorListGrouping(this.columnOneProcessorList, GlobalConstants.ENGLISH);
      this.processorListColumnTwo = Object.keys(group1).map(function (key) {
        return { order: key, nameInEng: group2[key] };
      });
      this.processorListColumnTwo.sort((a, b) => b.order - a.order);
    });
  }

  setProcessorListGrouping(list, type) {
    if (type === GlobalConstants.TRANSLATED) {
      let groups = list.reduce(function (obj, item) {
        obj[item.order] = obj[item.order] || [];
        obj[item.order].push(item.name);
        return obj;
      }, {});
      return groups;
    } else {
      let groups = list.reduce(function (obj, item) {
        obj[item.order] = obj[item.order] || [];
        obj[item.order].push(item.nameInEng);
        return obj;
      }, {});
      return groups;
    }
  }

  getProcessorList() {
    this.isProcessorListExpanded = !this.isProcessorListExpanded;
  }

  getOSList() {
    this.isOSListExpanded = !this.isOSListExpanded;
  }

  getGraphicsList() {
    this.isGraphicsListExpanded = !this.isGraphicsListExpanded;
  }

  downloadTemplate() {
    const csvHeaders = this.createSKUCSVHeaders();
    let tempHeaders = csvHeaders.join(',');
    let todayTime = new Date();
    let month = (todayTime.getMonth() + 1);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.SKU_FILENAME;
    let userfilename = month + '_' + day + '_' + year + '_' + filename;
    const blob = new Blob(['\ufeff' + tempHeaders], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf(GlobalConstants.SAFARI) !== -1 && navigator.userAgent.indexOf(GlobalConstants.CHROME) === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  onFilechange(fileInput: any) {
    this.resetValidationChecker();
    this.skuValidationError = false;
    this.fileName = fileInput.target.files[0].name;
    const fileType = this.fileName.split('.').pop();
    if ((fileType || '').toLowerCase() !== GlobalConstants.FILE_TYPE_CSV) {
      this.showcsvError = true;
      return;
    } else {
      this.showcsvError = false;
    }
    const reader = new FileReader();
    reader.readAsText(fileInput.target.files[0], GlobalConstants.ENCODING_TYPE);
    reader.onload = _event => {
      this.getParseCSVdata(reader.result);
    };
    this.file = fileInput.target.files[0];
    fileInput.target.value = null;
    this.skuFileName = this.fileName;
  }

  resetValidationChecker() {
    this.riPositiveValueChecker = 0;
    this.riRangeErrorChecker = 0;
    this.dasTeteDecimalPointChecker = 0;
    this.dasTroncDecimalPointChecker = 0;
    this.dasMembreDecimalPointChecker = 0;
  }

  createSKUCSVHeaders() {
    const skuCSVHeadersObj = {
      skuHeaders: []
    };

    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.SKU_CODE);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.BATTERY_LIFE);
    if (!this.isPriceSupress) {
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PRIMARY_PRICE);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.SECONDARY_PRICE);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PRICE_STRIKETHROUGH);
    }
    if (this.isCustomTileEnabled) {
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.CUSTOM_MAIN_TILE_ID);
    }
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.SEGMENT_ID_CSV);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROMOCONTENT_1);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROMOCONTENT_2);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROMOCONTENT_3);
    if (this.isRepairabilityIndexEnabled) {
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.REPAIRABILITY_INDEX_COL_NAME);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DAS_TETE_COL_NAME);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DAS_TRONC_COL_NAME);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DAS_MEMBRE_COL_NAME);
    }
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.INTERNAL_NAME);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.NAME_OF_THE_DEVICE);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROCESSOR);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.GRAPHICS_CSV);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.STORAGE);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.MEMORY_CSV);
    skuCSVHeadersObj.skuHeaders.push(GlobalConstants.OPERATING_SYSTEM_CSV);

    return skuCSVHeadersObj.skuHeaders;
  }

  getParseCSVdata(data) {
    let csvArray = data.split('\n');
    let csvJsonObj = [];
    let csvData = [];
    this.emptyDeviceSkuList = [];
    this.emptyProcessorsList = [];
    this.unMatchedProcessorList = [];
    this.emptyPrimaryPriceList = [];
    const headersCsv = csvArray[0].replace('\r', '').split(',');
    const skuHeadersObj = {
      skuHeaders: []
    };
    skuHeadersObj.skuHeaders.push(GlobalConstants.SKU_CODE);
    skuHeadersObj.skuHeaders.push(GlobalConstants.BATTERY_LIFE);
    if (!this.isPriceSupress) {
      skuHeadersObj.skuHeaders.push(GlobalConstants.PRIMARY_PRICE);
      skuHeadersObj.skuHeaders.push(GlobalConstants.SECONDARY_PRICE);
      skuHeadersObj.skuHeaders.push(GlobalConstants.PRICE_STRIKETHROUGH);
    }
    if (this.isCustomTileEnabled && headersCsv.includes(GlobalConstants.CUSTOM_MAIN_TILE_ID)) {
      skuHeadersObj.skuHeaders.push(GlobalConstants.CUSTOM_MAIN_TILE_ID);
    }
    skuHeadersObj.skuHeaders.push(GlobalConstants.SEGMENT_ID_CSV);
    skuHeadersObj.skuHeaders.push(GlobalConstants.PROMOCONTENT_1);
    skuHeadersObj.skuHeaders.push(GlobalConstants.PROMOCONTENT_2);
    skuHeadersObj.skuHeaders.push(GlobalConstants.PROMOCONTENT_3);
    if (this.isRepairabilityIndexEnabled) {
      skuHeadersObj.skuHeaders.push(GlobalConstants.REPAIRABILITY_INDEX_COL_NAME);
      skuHeadersObj.skuHeaders.push(GlobalConstants.DAS_TETE_COL_NAME);
      skuHeadersObj.skuHeaders.push(GlobalConstants.DAS_TRONC_COL_NAME);
      skuHeadersObj.skuHeaders.push(GlobalConstants.DAS_MEMBRE_COL_NAME);
    }
    if (headersCsv.includes(GlobalConstants.INTERNAL_NAME) && headersCsv.includes(GlobalConstants.NAME_OF_THE_DEVICE)
      && headersCsv.includes(GlobalConstants.PROCESSOR) && headersCsv.includes(GlobalConstants.GRAPHICS_CSV)
      && headersCsv.includes(GlobalConstants.STORAGE) && headersCsv.includes(GlobalConstants.MEMORY_CSV)
      && headersCsv.includes(GlobalConstants.OPERATING_SYSTEM_CSV)) {
      skuHeadersObj.skuHeaders.push(GlobalConstants.INTERNAL_NAME);
      skuHeadersObj.skuHeaders.push(GlobalConstants.NAME_OF_THE_DEVICE);
      skuHeadersObj.skuHeaders.push(GlobalConstants.PROCESSOR);
      skuHeadersObj.skuHeaders.push(GlobalConstants.GRAPHICS_CSV);
      skuHeadersObj.skuHeaders.push(GlobalConstants.STORAGE);
      skuHeadersObj.skuHeaders.push(GlobalConstants.MEMORY_CSV);
      skuHeadersObj.skuHeaders.push(GlobalConstants.OPERATING_SYSTEM_CSV);
    }

    // Logic to check whether CSV template columns are in order
    this.csvTemplateError = headersCsv.length === skuHeadersObj.skuHeaders.length
      && this.compareSKUCSVArrays(headersCsv, skuHeadersObj.skuHeaders) ? false : true;
    if (!this.csvTemplateError) {
      const skuCSVHeadersObj = {
        skuHeaders: []
      };
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.SKU_CODE_COLUMN);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.BATTERY_LIFE_COLUMN);
      if (!this.isPriceSupress) {
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PRIMARY_PRICE_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.SECONDARY_PRICE_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PRICE_STRIKE_THROUGH);
      }
      if (this.isCustomTileEnabled && headersCsv.includes(GlobalConstants.CUSTOM_MAIN_TILE_ID)) {
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.CUSTOM_MAIN_TILE_ID_CSV);
      }
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.SEGMENT_ID_COLUMN);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROMOTIONAL_CONTENT_GROUP_1_ID);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROMOTIONAL_CONTENT_GROUP_2_ID);
      skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROMOTIONAL_CONTENT_GROUP_3_ID);
      if (this.isRepairabilityIndexEnabled) {
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.REPAIRABILITY_INDEX);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DAS_TETE);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DAS_TRONC);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DAS_MEMBRE);
      }
      if (headersCsv.includes(GlobalConstants.INTERNAL_NAME) && headersCsv.includes(GlobalConstants.NAME_OF_THE_DEVICE)
        && headersCsv.includes(GlobalConstants.PROCESSOR) && headersCsv.includes(GlobalConstants.GRAPHICS_CSV)
        && headersCsv.includes(GlobalConstants.STORAGE) && headersCsv.includes(GlobalConstants.MEMORY_CSV)
        && headersCsv.includes(GlobalConstants.OPERATING_SYSTEM_CSV)) {
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.INTERNAL_NAME_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.DEVICE_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.PROCESSOR_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.GRAPHICS_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.STORAGE_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.MEMORY_COLUMN);
        skuCSVHeadersObj.skuHeaders.push(GlobalConstants.OS_COLUMN);
      }
      let csvHeaders = skuCSVHeadersObj.skuHeaders;
      for (var i = 1; i < csvArray.length; i++) {
        if ((csvArray[i].split(',').length === 1) && (csvArray[i].length === 0)) {
          csvArray.pop(i);
        }
      }
      this.isSkuCodeAvailableError = csvArray[1] ? false : true;
      for (var i = 1; i < csvArray.length; i++) {
        csvData = csvArray[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/g);
        var csvObj = {};
        let promoContentArray = [];
        let primaryPriceValue = "";
        let priceStrikeValue = "";
        let customMainTileValue = "";
        let segmentIdValue = "";
        let secondaryPriceValue = "";
        let repairabilityIndexValue = "";
        let dasTeteValue = "";
        let dasTroncValue = "";
        let dasMembreValue = "";
        for (var j = 0; j < csvData.length; j++) {
          if (csvHeaders[j] === GlobalConstants.PROMOTIONAL_CONTENT_GROUP_1_ID
            || csvHeaders[j] === GlobalConstants.PROMOTIONAL_CONTENT_GROUP_2_ID
            || csvHeaders[j] === GlobalConstants.PROMOTIONAL_CONTENT_GROUP_3_ID) {
            let promoData = csvData[j].replace(/\n|\r/g, "");
            this.isPromoExists = this.skuService.promoContentList.some(ele => ele.id === promoData);
            if (promoData !== '' && this.isPromoExists) {
              promoContentArray.push(promoData);
            }
          } else if (csvHeaders[j] === GlobalConstants.CUSTOM_MAIN_TILE_ID_CSV && csvData[j] !== "" && this.isCustomTileEnabled) {
            let customData = csvData[j].replace(/\n|\r/g, "");
            this.isCustomTileexists = this.skuService.mainTileContentList.some(ele => ele.id === customData);
            if (this.isCustomTileexists && customData !== "") {
              customMainTileValue = customData;
            }
          } else if (csvHeaders[j] === GlobalConstants.SEGMENT_ID_COLUMN && csvData[j] !== "") {
            let segmentData = csvData[j].replace(/\n|\r/g, "");
            this.isSegmentExists = this.skuService.segmentContentList.some(ele => ele.id === segmentData);
            if (this.isSegmentExists && segmentData !== "") {
              segmentIdValue = segmentData;
            }
          }
          else if (csvHeaders[j] === GlobalConstants.PRICE_STRIKE_THROUGH && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            csvData[j] = csvData[j] === 'T' ? 'T' : 'F';
            priceStrikeValue = csvData[j];
          }
          else if (csvHeaders[j] === GlobalConstants.PRIMARY_PRICE_COLUMN && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            primaryPriceValue = csvData[j];
          } else if (csvHeaders[j] === GlobalConstants.SECONDARY_PRICE_COLUMN && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            secondaryPriceValue = csvData[j];
          } else if (csvHeaders[j] === GlobalConstants.REPAIRABILITY_INDEX && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            repairabilityIndexValue = csvData[j];
          } else if (csvHeaders[j] === GlobalConstants.SKU_CODE_COLUMN && csvData[j] !== "") {
            //Removing first and last quote and replacing double with single to handle - Laptop 14"
            csvData[j] = csvData[j].replace(/(^")|("$)/g, '').replace('""', '"');
            csvObj[GlobalConstants.SKU_CODE_COLUMN] = csvData[j].replace(/\u00A0/g, " ").trim();
          } else if (csvHeaders[j] === GlobalConstants.DAS_TETE && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            dasTeteValue = csvData[j];
          } else if (csvHeaders[j] === GlobalConstants.DAS_TRONC && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            dasTroncValue = csvData[j];
          } else if (csvHeaders[j] === GlobalConstants.DAS_MEMBRE && csvData[j] !== "") {
            csvData[j] = csvData[j].replace(/"/g, '').trim();
            dasMembreValue = csvData[j];
          } else {
            csvObj[csvHeaders[j]?.trim()] = csvData[j].trim();
          }
        }
        csvObj[GlobalConstants.PROMOTIONAL_CONTENT_IDS] = promoContentArray;
        csvObj[GlobalConstants.PRIMARY_PRICE_COLUMN] = primaryPriceValue;
        csvObj[GlobalConstants.PRICE_STRIKE_THROUGH] = priceStrikeValue;
        csvObj[GlobalConstants.SECONDARY_PRICE_COLUMN] = secondaryPriceValue;
        csvObj[GlobalConstants.CUSTOM_MAIN_TILE_ID_CSV] = customMainTileValue;
        csvObj[GlobalConstants.SEGMENT_ID_COLUMN] = segmentIdValue;
        csvObj[GlobalConstants.REPAIRABILITY_INDEX] = repairabilityIndexValue;
        csvObj[GlobalConstants.DAS_TETE] = dasTeteValue;
        csvObj[GlobalConstants.DAS_TRONC] = dasTroncValue;
        csvObj[GlobalConstants.DAS_MEMBRE] = dasMembreValue;
        csvJsonObj.push(csvObj);
      }
      if (csvJsonObj.length > 0) {
        this.validateCSVRows(csvJsonObj);
      }
      else {
        this.resetValidationChecker();
      }
      let duplicateSku = [];
      let skuCodeList = csvJsonObj.map(item => { return item.skuCode });
      let removeEmptyskuList = skuCodeList.filter(ele => { return ele !== ''})
      let csvJsonObj1 = removeEmptyskuList.map(ele => ele.toLowerCase()); //Fix for IIT2-9936: SKU codes are now made case in-sensitive; [Eg:- SKU1 is same as SKU1, skU1, sKu1 etc..].
      csvJsonObj1.forEach((item, idx) => {
        this.isSkuCodeDuplicate = csvJsonObj1.indexOf(item) != idx ? true : false;
        if (this.isSkuCodeDuplicate) {
          duplicateSku.push(item);
        }
      });
      this.isSkuCodeDuplicateError = duplicateSku.length > 0 ? true : false;
      let batteryLife = []
      let skuUnAvailability = [];
      csvJsonObj.forEach(item => {
        if (item.batteryLife) {
          this.isBatteryPositive = item.batteryLife > 0 ? false : true;
          if (this.isBatteryPositive) {
            batteryLife.push(item.batteryLife)
          }
        }
        this.isSkuCodeAvailable = item.skuCode ? false : true;
        if (this.isSkuCodeAvailable) {
          skuUnAvailability.push(item.skuCode)
        }
        this.isDeviceNameExists = item.deviceName ? true : false;
        if (!this.isDeviceNameExists) {
          this.emptyDeviceSkuList.push(item.skuCode)
        }
        if ((item.secondaryPrice !== '' || item.priceStrikethrough !== '') && item.primaryPrice === '') {
          this.isPrimaryPriceExists = false;
        } else {
          this.isPrimaryPriceExists = true;
        }
        if (!this.isPrimaryPriceExists) {
          this.emptyPrimaryPriceList.push(item.skuCode)
        }
        if (item.processor === '') {
          this.isProcessorExists = item.processor ? true : false;
          if (!this.isProcessorExists) {
            this.emptyProcessorsList.push(item.skuCode)
          }
        } else {
          let inputProcessor;
          this.incorrectProcessorExists = processorNamesConstant.some((ele) => {
            if(ele.name === item.processor) {
              inputProcessor = ele.nameInEng;
              return true;
            }
          });
                    
          if (!this.incorrectProcessorExists) {
            this.unMatchedProcessorList.push(item.skuCode);
            item.processor = '';
          }
          else {
            item.processor = inputProcessor;
          }
        }
        if (item.operatingSystem !== '') {
          let inputOs;
          this.incorrectOSExists = osNameConstant.some(ele => {
            if(ele.name === item.operatingSystem) {
              inputOs = ele.nameInEng;
              return true;
            }
          });
          if (!this.incorrectOSExists) item.operatingSystem = '';
          else item.operatingSystem = inputOs;
        }
        if (item.graphicsCard !== '') {
          let inputGraphicCard;
          this.incorrectGraphicsCardExists = graphicsModelsConstant.some(ele => {
            if(ele.name === item.graphicsCard) {
              inputGraphicCard = ele.nameInEng;
              return true;
            }
          });
          if (!this.incorrectGraphicsCardExists) item.graphicsCard = '';
          else item.graphicsCard = inputGraphicCard;
        }
      });
      this.isBatteryLifeError = batteryLife.length > 0 ? true : false;
      if (csvArray[1]) {
        this.isSkuCodeAvailableError = skuUnAvailability.length > 0 ? true : false;
      }
      if ((!(this.isSkuCodeDuplicateError || this.isSkuCodeAvailableError || this.isBatteryLifeError || (this.riPositiveValueChecker > 0) || (this.riRangeErrorChecker > 0) || (this.dasTeteDecimalPointChecker > 0) || (this.dasTroncDecimalPointChecker > 0) || (this.dasMembreDecimalPointChecker > 0))) && !this.showcsvError && !this.csvTemplateError) {
        this.skuValidationError = true;
        let inputParams = {
          skuFileName: this.skuFileName,
          skuList: csvJsonObj
        }
        this.skuService.updateSkuCsv({ skuCSVData: JSON.stringify(inputParams) })
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(() => {
            this.successPopUp = true;
          })
        const uploadedCsvSKU = inputParams.skuList.map(x => x.skuCode);
        this.googleAnalyticsService.skucsvUpload(uploadedCsvSKU.length, uploadedCsvSKU); // IIT2-5312
      } else {
        this.file = undefined;
        this.skuFileName = undefined;
        this.fileName = undefined;
      }
    }
  }

  validateCSVRows(data: any[]) {
    data.forEach(item => {
      if (item.repairabilityIndex) {
        //Check if cell value contains comma
        if (item.repairabilityIndex.indexOf(',') != -1) {
          var value = item.repairabilityIndex.split(',');
          var riDecimalValue = value[0].concat('.').concat(value[1]);
          this.repairabilityPositive = riDecimalValue >= 0 ? false : true;
          if (!this.repairabilityPositive) {
            this.isRepairabilitySizeError = riDecimalValue >= 10.1 ? true : false;
            if (this.isRepairabilitySizeError) this.riRangeErrorChecker++;
            if (item.repairabilityIndex.includes(',') && item.repairabilityIndex.split(',')[1].length >= 2) {
              item.repairabilityIndex = item.repairabilityIndex.substring(0, 3);
            }
          } else {
            this.riPositiveValueChecker++;
          }
        } else {
          this.repairabilityPositive = item.repairabilityIndex >= 0 ? false : true;
          if (!this.repairabilityPositive) {
            this.isRepairabilitySizeError = item.repairabilityIndex >= 10.1 ? true : false;
            if (this.isRepairabilitySizeError) this.riRangeErrorChecker++;
            if (item.repairabilityIndex.includes('.') && item.repairabilityIndex.split('.')[1].length >= 2) {
              item.repairabilityIndex = item.repairabilityIndex.substring(0, 3);
            }
          } else {
            this.riPositiveValueChecker++;
          }
        }
      }

      if (item.das_tete) {
        item.das_tete = this.validateDASWithCommas(item.das_tete, GlobalConstants.DAS_TETE_COL_NAME);
      }

      if (item.das_tronc) {
        item.das_tronc = this.validateDASWithCommas(item.das_tronc, GlobalConstants.DAS_TRONC_COL_NAME);
      }

      if (item.das_membre) {
        item.das_membre = this.validateDASWithCommas(item.das_membre, GlobalConstants.DAS_MEMBRE_COL_NAME);
      }
    });
  }

  validateDASWithCommas(cellValue, columnName) {
    //Check if cell value contains comma
    if (cellValue.indexOf(',') != -1) {
      var value = cellValue.split(',');
      var decimalVal = value[0].concat('.').concat(value[1]);
      cellValue = this.validateDASValues(decimalVal, columnName, cellValue);
    } else {
      cellValue = this.validateDASValues(cellValue, columnName);
    }
    return cellValue;
  }

  validateDASValues(dasVal, dasCol, value?) {
    let isValueNegative = dasVal >= 0 ? false : true;
    if (isValueNegative) {
      if (dasCol === GlobalConstants.DAS_TETE_COL_NAME) {
        this.dasTeteDecimalPointChecker++;
      } else if (dasCol === GlobalConstants.DAS_TRONC_COL_NAME) {
        this.dasTroncDecimalPointChecker++;
      } else this.dasMembreDecimalPointChecker++;
    } else {
      if (value != undefined && value.indexOf('.') == -1 && value == -0)
        value = '0';
    }
    return (value == undefined) ? dasVal : value;
  }

  closeModal() {
    this.successPopUp = false;
  }

  compareSKUCSVArrays(inputArray, tempArray) {
    const isArrEqual = inputArray.length == tempArray.length && inputArray.every(function (element, index) {
      return element === tempArray[index];
    });
    return isArrEqual;
  }
}
